import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const siteLinks = [
    { path: '/', label: 'Home' },
    { path: '/about-us', label: 'About Us' },
    { path: '/programs', label: 'Programs' },
    { path: '/events', label: 'Events' },
    { path: '/board-members', label: 'Board Members' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/resources', label: 'Resources' },
    { path: '/contact', label: 'Contact' },
  ];

  const footerLinks = [
    { path: '/privacy', label: 'Privacy Policy' },
    { path: '/terms', label: 'Terms of Service' },
    { path: '/refund-policy', label: 'Refund Policy' },
  ];

  return (
    <footer className="footer-shell">
      <div className="footer-panel">
        <div className="footer-cta">
          <div className="footer-cta-copy">
            <span className="eyebrow footer-eyebrow">Victoria&apos;s Place</span>
            <h2>Support a place where children can grow, belong, and be fully seen.</h2>
            <p>
              Victoria&apos;s Place serves children with Down Syndrome and the families who walk
              alongside them. Every gift, partnership, and volunteer hour helps keep that care warm,
              steady, and welcoming.
            </p>
          </div>

          <div className="footer-cta-actions">
            <Link to="/give" className="footer-button footer-button--primary">
              Give
            </Link>
            <a
              href="https://swipesimple.com/links/lnk_d284786b24febcc9ad505269075ad362"
              className="footer-button footer-button--secondary"
              target="_blank"
              rel="noreferrer"
            >
              Donate with Swipesimple
            </a>
            <Link to="/contact" className="footer-button footer-button--secondary">
              Volunteer
            </Link>
          </div>
        </div>

        <div className="footer-grid">
          <div className="footer-brand-column">
            <div className="footer-brand-lockup">
              <span className="footer-brand-mark">
                <img src={logo} alt="" className="footer-brand-logo" />
              </span>
              <div>
                <p className="footer-brand-name">Victoria&apos;s Place</p>
                <p className="footer-brand-tag">Faith. Family. Community</p>
              </div>
            </div>

            <p className="footer-description">
              A nonprofit rooted in faith, family, encouragement, and the belief that children
              deserve safe places to create, learn, and belong.
            </p>

            <div className="footer-location-block">
              <span className="footer-caption">Based in</span>
              <strong>Columbia, South Carolina</strong>
            </div>
          </div>

          <div className="footer-column">
            <h3>Navigate</h3>
            <ul className="footer-link-list">
              {siteLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h3>Get Involved</h3>
            <p className="footer-column-copy">
              Questions, volunteer interest, program support, and partnerships are always welcome.
            </p>
            <Link to="/contact" className="footer-inline-link">
              Contact Victoria&apos;s Place
            </Link>
          </div>

          <div className="footer-column">
            <h3>Policies</h3>
            <ul className="footer-link-list">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom-bar">
          <p><a href="https://blissits.com" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: "0.2em" }}>Built by Bliss</a></p>
          <p>&copy; {currentYear} Victoria&apos;s Place. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
